import kd_header from "kd/assets/KD_logo/kd_header2023.png";
import KeyInfoSection from "./Sections/KeyInfo/KeyInfo";
import ProgramSection from "./Sections/Program/Program";

const FrontPage = () => {
  return (
    <>
      <img src={kd_header} alt="kd_header2023" width="100%" />
      <KeyInfoSection />
      <ProgramSection />
    </>
  );
};

export default FrontPage;
